import * as React from "react";
const SvgLess24 = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fillRule="evenodd" d="M2.5 12a.77.77 0 0 1 .77-.77h17.46a.77.77 0 0 1 0 1.54H3.27A.77.77 0 0 1 2.5 12" clipRule="evenodd" /></svg>;
export default SvgLess24;